import { render, staticRenderFns } from "./touchHelp.vue?vue&type=template&id=079ae0ce&scoped=true&"
import script from "./touchHelp.vue?vue&type=script&lang=js&"
export * from "./touchHelp.vue?vue&type=script&lang=js&"
import style0 from "./touchHelp.vue?vue&type=style&index=0&id=079ae0ce&prod&lang=scss&scoped=true&"
import style1 from "./touchHelp.vue?vue&type=style&index=1&id=079ae0ce&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079ae0ce",
  null
  
)

export default component.exports